import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';

import { type FC, useEffect, useState } from 'react';

import { useUserSelector } from '@/packages/redux-state/store/slices/user';

import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';

import { trackPageViewCollect } from './tracking';

type VisitedOffersAnalyticsProps = {
  isFetchingOffers: boolean;
  offers: IOfferForDesktopEnrichedV3Schema[];
};

export const VisitedOffersAnalytics: FC<VisitedOffersAnalyticsProps> = ({ isFetchingOffers, offers }) => {
  const { isLoaded, isOfferVisited } = useVisitedOffersContext();
  const user = useUserSelector();
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    if (isFetchingOffers) {
      setIsFirstLoad(true);
    }
  }, [isFetchingOffers]);

  useEffect(() => {
    /**
     * В стейте есть специальное поле isFirstLoad, которое переключается, когда загружаются новые офферы
     * Это нужно, чтобы распознать, когда офферы только загрузились (такого флага нет в react-query) и отличить, например, от добавления в избранное
     * После того, как офферы отрисовались (флаг из isFetching и isFirstLoad), отправляет аналитика на показ и флаг меняется в false.
     * Цикл повторяется при прогрузке новых офферов
     */
    const isFirstRender = !isFetchingOffers && isFirstLoad;

    if (isLoaded && offers.length && isFirstRender) {
      trackPageViewCollect({
        products: offers.map(({ id }, index) => ({
          extra: isOfferVisited(id) ? { is_viewes: true } : undefined,
          id,
          offerType: 'offer' as const,
          position: index + 1,
        })),
        user,
      });

      setIsFirstLoad(false);
    }
  }, [isFetchingOffers, isFirstLoad, isLoaded, isOfferVisited, offers, user]);

  return null;
};
